import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel">
      <XCircle size={64} className="mx-auto mb-6" style={{ color: "var(--terracotta)" }} />
      <h1 className="font-serif text-4xl mb-4" style={{ color: "var(--ink)" }}>{t({ en: "Payment cancelled", fr: "Paiement annulé" })}</h1>
      <p className="mb-8" style={{ color: "var(--ink-2)" }}>{t({ en: "Your session hasn't been booked yet. You can try again anytime.", fr: "Votre séance n'a pas encore été réservée. Vous pouvez réessayer à tout moment." })}</p>
      <Link to="/book" className="btn-accent">{t({ en: "Back to booking", fr: "Retour à la réservation" })}</Link>
    </div>
  );
}
